exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_QRCode_ISYubjVaytvvHh9qVrhLY {\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #ffffff;\n  overflow: hidden;\n  box-shadow: 0 1px 6px 0 #88888896;\n\n}\n\n.IA_QRCodeImage_11J_7K8cJK0zbs2ro5ur7O {\n  float: left;\n  overflow: hidden;\n  width: 100%;\n  position: relative;\n}", ""]);

// Exports
exports.locals = {
	"IA_QRCode": "IA_QRCode_ISYubjVaytvvHh9qVrhLY",
	"IA_QRCodeImage": "IA_QRCodeImage_11J_7K8cJK0zbs2ro5ur7O"
};